/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toDownloadProps, toDownloadRequest } from './translator/download'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchDownload, PostDownload } from '@/infrastructure/network/Monitaro/requests/download'
import { IDownloadProps } from '@/entities/Download'

export default class Download extends MonitaroGatewayBase {
  async FetchDownload(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDownload(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.download.map((prop) => toDownloadProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostDownload(params: IDownloadProps) {
    const { download } = await this.apiClient.request(new PostDownload(toDownloadRequest(params)))
    return toDownloadProps(download)
  }
}
